import { __awaiter } from "tslib";
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import css from './BeforeAdornment.css';
import { useSelector } from 'react-redux';
import { getSegments } from '@websky/core/src/SearchForm/store/segments/selectors';
import { getPassengersForRequest, getTotalPassengersCount } from '@websky/core/src/SearchForm/store/passengers/selectors';
import { useConfig } from '@websky/core/src/context';
import { generateOfferHotelLink } from '@websky/core/src/SearchForm/utils';
const BeforeAdornment = () => {
    const { t } = useTranslation('SearchForm');
    const searchFormState = useSelector(state => state);
    const segments = useSelector(getSegments);
    const passengersCount = useSelector(getTotalPassengersCount);
    const passengers = useSelector(getPassengersForRequest);
    const { global: { companyInfo: { iataCode } }, SearchForm: { offerHotels, offerHotelsLink, offerHotelsMainLink, offerHotelsSupplier, offerHotelsAdditionalId, offerHotelsUtm } } = useConfig();
    const handleClick = React.useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        const result = yield generateOfferHotelLink(offerHotelsLink, segments, passengersCount, passengers, iataCode, offerHotelsSupplier, offerHotelsAdditionalId, offerHotelsUtm);
        window.open(result || offerHotelsMainLink || offerHotelsLink, '_blank');
    }), [searchFormState]);
    if (!offerHotels) {
        return null;
    }
    return (React.createElement("div", { className: css.container },
        React.createElement("div", { className: css.aviaTicketsBtn }, t('Aviatickets')),
        React.createElement("a", { className: css.hotelsBtn, onClick: handleClick }, t('Hotels'))));
};
export default BeforeAdornment;
